module.exports = __webpack_public_path__ + "media/images/client-10-cc20a9b5eb32c83e15d1cacce86cfaa3.png";